// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/low-flying-wire-obstacle-hazards.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/low-flying-wire-obstacle-hazards/low-flying-wire-obstacle-hazards.js';

mount([g0]);
